import React, { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    Pressable,
    ScrollView,
    Modal,
    Platform,
    Linking,
    FlatList,
    Animated,
} from "react-native";

import { White, WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Header from "../components/Header";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
import * as Animatable from "react-native-animatable";
import { ImageBackground, TextInput } from "react-native-web";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import InvoiceDetails from "./InvoiceDetails";
import ReturnsDetails from "./RetrurnsDetails";
import DateTimePicker from '@react-native-community/datetimepicker';
import { Link } from "@react-navigation/native";
import DesktopSidebar from "../utils/DesktopSidebar";
import ProductDetails from "./ProductDetails";
import OrderNow from "./OrderNow";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let brandPos = 1;
let brandFlag = 1;
let isMobile = false;
let scale = 1;
const filterName = [];
const imgProfile = require("../images/Header/Profile.png");
const imgForward = require("../images/Shop/forward.png");
const jo1 = require("../images/home/jo1.png");
const jo2 = require("../images/home/jo2.png");
const jo3 = require("../images/home/jo3.png");
const jo4 = require("../images/home/jo4.png");
const jo5 = require("../images/home/jo5.png");
const joImgs = [jo1, jo2, jo3, jo4, jo5];
const SOAimg = require("../images/ClientHomePage/SOA.png");
const IRimg = require("../images/ClientHomePage/IR.png");
const notificationImg = require("../images/orderNow/notifications.png");
const privacyImg = require("../assets/privacy_policy_icon.png");


class Other extends Component {
    constructor(props) {
        super(props);

        this.state = {
            advs: [],
            categories: [],
            brands: [],
            consumerBrands: [],
            joImgPos: 0,
            advImgPos: 0,
        };
    }
    Pressables = {};

    async componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        loaderHandler.showLoader(STRINGS.loading, this);
        let catgResp = await ServerOperations.getCategories();
        let brandsResp = await ServerOperations.getConumerBrands();
        let advResp = await ServerOperations.getAdvImages();
        this.setState({ categories: catgResp, consumerBrands: brandsResp, advs: advResp });
        // from here

        const brands = [];
        brandsResp.map(async brand => {
            Image.getSize(brand.IMG, (width, height) => {
                const widthx = isMobile ? width / height > 3 ? 100 : 40 * width / height : width / height > 3 ? 200 : 60 * width / height;
                brands.push(<Image source={brand.IMG} style={{ height: isMobile ? 40 : 60, width: widthx }} resizeMode="contain" />);
            });
        }
        );



        setTimeout(() => {
            for (let i = 0; i < 10; i++) {
                brands.push(...brands);
            }
            this.setState({ brands });
            this.scrollX = new Animated.Value(0);
            this.brandPos = 0;
            this.brandFlag = 1; // Adjust as needed 
            this.brandsView = React.createRef();

            this.interval = setInterval(() => { this.scrollBrand(); }, 45);
            setInterval(() => {
                let joImgPos = this.state.joImgPos += 1;
                if (joImgPos >= joImgs.length) joImgPos = 0;
                this.setState({ joImgPos });
            }, 1500);
        }, 500);


        loaderHandler.hideLoader();
    }


    scrollBrand = () => {
        this.brandPos += this.brandFlag;
        const x = this.brandPos * 4;
        if (this.brandsView.current) {
            Animated.timing(this.scrollX, {
                toValue: x,
                duration: 45, // Adjust the duration for smooth scrolling 
                useNativeDriver: true,
            }).start(() => {
                this.brandsView.current.scrollToOffset({ offset: x, animated: false });
            });
        }
    }



    renderMobile() {
        scale = width / 420;
        return (
            <View style={styles.container}>
                {Commons.renderAppHeader(0.3, this)}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}
                    contentContainerStyle={{ paddingBottom: 120 }}>
                    <View style={{ width, }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                        {this.renderPart2Mobile()}
                        {this.renderPart3Mobile()}
                    </View>
                </ScrollView>
                {Commons.renderAppFooter({}, this, '', '', '', '#52C0EE', true)}
            </View >
        );
    }

    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
        });
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        width = Commons.getWidth();
        styles = this.styles();
        marginTop = 300;
        styles = this.styles();

        return (
            <View style={styles.container}>
                <Header
                    title={STRINGS.company_name}
                    leftView={Styles.drawerButtonDark(this.props.navigation)}
                    light={true}
                    navigation={this.props.navigation}
                    style={{ backgroundColor: this.state.scrolled ? 'rgba(192, 186, 94, 0.8)' : 'rgba(192, 186, 94, 1)' }}
                />
                <ScrollView scrollEventThrottle={100} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    {Commons.loadFonts(this, false)}
                    {this.renderPart1()}
                    {this.renderPart2()}
                    {this.renderPart3()}
                    {this.renderPart4()}
                    {Commons.renderFooter({}, this, '', '', '', '', this.state.isOther)}
                </ScrollView>
            </View>
        );
    }



    renderPart1 = () => {
    }


    renderPart1Mobile = () => {
        return (
            <View style={{ display: 'flex', height: 201, alignItems: 'flex-start', gap: 8, flexShrink: 0, alignSelf: 'stretch', marginHorizontal: 16, opacity: 0.3 }}>
                <View style={{ justifyContent: 'center', alignItems: 'center', width: width - 20, height: 176.622 }}>
                    <FlatList
                        data={this.state.advs}
                        horizontal
                        showsHorizontalScrollIndicator={false}
                        keyExtractor={(item, index) => index.toString()}
                        renderItem={({ item }) => (
                            <Image
                                source={item.IMGURL}
                                style={{
                                    width: width - 20,
                                    height: 176,
                                    borderRadius: 12,
                                    marginRight: 12,
                                }}
                                resizeMode="cover"
                            />
                        )}
                        contentContainerStyle={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            paddingVertical: 8,
                        }}
                    />
                </View>
            </View>
        );
    }

    renderBrandItem = ({ item }) => {
        return (item);
    }


    onBrandScroll = (e) => {
        try {
            const endReached =
                parseInt(e.nativeEvent.contentOffset.x) +
                parseInt(e.nativeEvent.layoutMeasurement.width) -
                parseInt(e.nativeEvent.contentSize.width) ==
                0;
            const startReached = e.nativeEvent.contentOffset.x == 0;
            if (endReached) {
                brandPos = 0;
                this.brandsView.scrollToOffset({ animated: false, offset: 0 });
            } else if (startReached) {
                brandFlag = 1;
            }
        } catch (err) { }
    };


    renderPart2 = () => {

    }

    renderCousumerBrands = () => {
        return (
            <View style={{ display: 'flex', width: width, height: 200, flexDirection: 'column' }}>
                <View style={{ flexDirection: "row", gap: 10, alignItems: "center", justifyContent: "center" }}>
                    {this.state.consumerBrands.map((item, index) =>
                        index >= 0 && index <= 4 && (
                            <TouchableOpacity style={{ display: 'flex', height: 67.998, width: 67.998, backgroundColor: 'rgba(238, 238, 238, 0.46)', margin: 4.89, borderRadius: 3.4, alignItems: 'center', justifyContent: 'center' }}>
                                <Image source={item.IMG} style={{ width: 52.698, height: 27.541 }} resizeMode="contain" />
                                <Text style={[AppStyles.categTextStyle, { position: 'absolute', bottom: 7.2 }]}> {item.NAME}</Text>
                            </TouchableOpacity>
                        )
                    )}
                </View>
                <View style={{ flexDirection: "row", gap: 10, alignItems: "center", justifyContent: "center" }}>
                    {this.state.consumerBrands.map((item, index) =>
                        index >= 5 && index <= 9 && (
                            <TouchableOpacity style={{ display: 'flex', height: 67.998, width: 67.998, backgroundColor: 'rgba(238, 238, 238, 0.46)', margin: 4.89, borderRadius: 3.4, alignItems: 'center', justifyContent: 'center' }}>
                                <Image source={item.IMG} style={{ width: 52.698, height: 27.541 }} resizeMode="contain" />
                                <Text style={[AppStyles.categTextStyle, { position: 'absolute', bottom: 7.2 }]}> {item.NAME}</Text>
                            </TouchableOpacity>
                        )
                    )}
                </View>
            </View>
        )
    };

    renderPart2Mobile = () => {
        const chunkArray = (arr, size) => {
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
            }
            return result;
        };

        // Split into 3 rows
        const rowCount = 3;
        let itemsPerRow = Math.ceil(this.state.consumerBrands.length / 1);
        let brandRows = chunkArray(this.state.consumerBrands, itemsPerRow);
        return (
            <View style={{ display: 'flex', alignSelf: 'stretch', flexDirection: 'column', gap: 9.771, marginHorizontal: 16, width: 555, opacity: 0.3 }}>
                <View>
                    <Text style={[AppStyles.appTitleStyle]}>{STRINGS.app_Brands}</Text>
                </View>
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{ flexDirection: 'column', gap: 1 }}
                    style={{ width: width - 20 }}
                >
                    {brandRows.map((row, rowIdx) => (
                        <View
                            key={rowIdx}
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'flex-start',
                                gap: 1,
                            }}
                        >
                            {row.map((item, idx) => (
                                <TouchableOpacity
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        height: 40.998,
                                        width: 70.998,
                                        backgroundColor: 'rgba(238, 238, 238, 0.46)',
                                        margin: 4.89,
                                        borderRadius: 3.4,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    onPress={() => {

                                    }}
                                >
                                    <Image source={item.IMG} style={{ width: 52.698, height: 27.541 }} resizeMode="contain" />
                                </TouchableOpacity>
                            ))}
                        </View>
                    ))}
                </ScrollView>
            </View>
        );
    }


    renderPart3 = () => {

    }



    renderPart3Mobile = () => {
        const otherTitles = [
            { title: STRINGS.Statement_of_Account_Desktop, onPress: () => window.location = './StatementOfAccount', sources: SOAimg, },
            { title: STRINGS.Invoice_Returns_Desktop, onPress: () => window.location = './InvoicesReturns', sources: IRimg, },
            { title: STRINGS.app_notifications, onPress: () => window.location = './appNotifications', sources: notificationImg, },
            { title: STRINGS.profile_Desktop, onPress: () => window.location = './profile', sources: imgProfile, },
        ];
        const itemStyle = { width: width - 60, height: 50, minWidth: 137.041, alignItems: 'center', justifyContent: 'flex-start', gap: 16, flexDirection: 'row', borderRadius: 10.793, backgroundColor: '#FFF', elevation: 2, shadowColor: '#000', shadowOffset: { width: 0, height: 1 }, shadowOpacity: 0.08, shadowRadius: 3 };
        return (
            <View style={{ alignSelf: 'stretch', marginHorizontal: 16, flexDirection: 'column', alignItems: 'center', gap: 8, backgroundColor: '#FFF', marginTop: 24, paddingVertical: 16, paddingBottom: 100 }}>
                <Text style={[AppStyles.otherTabTitle]}>{STRINGS.app_Other}</Text>
                <View style={{ gap: 16, alignSelf: 'stretch', backgroundColor: '#FFF' }}>
                    {otherTitles.map((title, index) => (
                        <TouchableOpacity key={index} style={itemStyle}
                            onPress={() => { title.onPress() }}>
                            <Image source={title.sources} style={{ width: 28.783, height: 28.783, marginHorizontal: 14 }} />
                            <Text style={[AppStyles.checkOutPaymentTerms, { color: Styles.appColor1 }]}>{title.title}</Text>
                        </TouchableOpacity>
                    ))}
                    <TouchableOpacity style={itemStyle}
                        onPress={() => Linking.openURL('https://jdsco.net/pdf/privacypolicy.pdf')}>
                        <Image source={privacyImg} style={{ width: 28.783, height: 28.783, marginHorizontal: 14 }} />
                        <Text style={[AppStyles.checkOutPaymentTerms, { color: Styles.appColor1 }]}>{STRINGS.privacy_policy}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        )

    }

    renderPart4 = () => {

    }

    renderPart4Mobile = () => {

    }

    renderPart5Mobile = () => {

    }




    renderPart6Mobile = () => {


    }
    renderPart7Mobile = () => {

    }


    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default Other;
